export const adminEquipmentListTableHead = [
  "#",
  "설비분류",
  "설비번호",
  "설비등급",
  "설비명",
  "제조사",
  "Model",
  "Serial No",
  // "이미지",
  "담당자",
  "생성날짜",
  "작성자",
];
export const createEquipmentListTableHead = [
  "#",
  "설비분류",
  "설비번호",
  "설비등급",
  "설비명",
  "제조사",
  "Model",
  "Serial No",
  // "이미지",
  "담당자",
  "생성날짜",
  "작성자",
  "편집",
];
export const curriculumListTableHead = [
  "#",
  "일정",
  "대분류",
  "중분류",
  "세분류",
  "교안등록",
  "부서명",
  "문제등록",
  "평가자/대상자",
  "평균점수",
  "QR Code",
  "편집/보고서/삭제",
];

export const editExamTableHead = [
  "#",
  "질문",
  "답안 1",
  "답안 2",
  "답안 3",
  "답안 4",
  "정답번호",
  "삭제여부",
];
export const myEvalTableHead = [
  "평가기간",
  "구분(대분류)",
  "중분류",
  "세분류",
  "응시상태",
  "최고점수",
  "응시횟수",
  "비고",
];
export const workOrderListTableHead = [
  "#",
  "상태",
  "일련번호",
  "작성부서",
  "작성자",
  "설비분류",
  "설비번호",
  "설비명",
  "요청내용",
  "요청일자",
];
export const workOrderRequestedListTableHead = [
  "#",
  "일련번호",
  "요청부서",
  "작성자",
  "분류",
  "설비번호",
  "설비명",
  "위험등급",
  "요청내용",
  "요청날짜",
  "편집",
];
